<template>
  <el-table-column
    prop="has_no_more_delivery"
    sortable="custom"
    label="Lesz még szállítás"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      <el-tag
        v-if="!scope.row.has_no_more_delivery && (scope.row.status === 'partly-done' || scope.row.status === 'sent')"
        size="small"
        type="success"
      >
        Igen
      </el-tag>
      <el-tag
        v-else
        size="small"
        type="danger"
      >
        Nem
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'has_no_more_delivery',
};
</script>
